<app-modal-layout [noXPadding]="true" [containerLayout]="containerLayout" class="mt-3">
    <ng-container *transloco="let t" title>{{ t('workspace_list_title') }}</ng-container>
    @if (selectedWorkspace$ | async; as selectedWorkspace) {
        @if (workspaces$ | async; as workspaces) {
            <div
                class="h-full flex flex-col md:max-h-[35rem] overflow-hidden md:w-[17.5rem] px-4"
                data-testid="workspace-list"
            >
                @if (workspaces.global) {
                    <app-workspace
                        class="max-md:w-full"
                        [workspace]="workspaces.global"
                        [canDelete]="false"
                        [showSelectedIcon]="containerLayout === 'BottomSheet'"
                        [selectedWorkspaceGuid]="selectedWorkspace.guid"
                        (selectWorkspace)="selectWorkspace($event)"
                        (edit)="openWorkspaceEditDialog(workspaces.global)"
                    ></app-workspace>
                }
                <app-tb-divider class="xsm:my-2 md:m-0"></app-tb-divider>
                <div class="overflow-auto -mr-[0.875rem] mt-2">
                    <div class="pr-[0.875rem]">
                        @for (workspace of workspaces.nonGlobal; track workspace.guid) {
                            <app-workspace
                                class="max-md:w-full"
                                [workspace]="workspace"
                                [selectedWorkspaceGuid]="selectedWorkspace.guid"
                                [showSelectedIcon]="containerLayout === 'BottomSheet'"
                                (selectWorkspace)="selectWorkspace($event)"
                                (edit)="openWorkspaceEditDialog(workspace)"
                            ></app-workspace>
                        }
                    </div>
                </div>
            </div>
        }
    }
    <div buttons>
        <app-tb-button
            *transloco="let tButtons; read: 'buttons'"
            [appearance]="containerLayout === ModalContainer.BottomSheet ? 'outlined' : 'text'"
            color="primary"
            icon="add_circle_outline"
            [class.w-full]="containerLayout === ModalContainer.BottomSheet"
            [class.pl-2]="containerLayout === ModalContainer.Menu"
            (click)="openWorkspaceCreateDialog()"
        >
            <span class="font-semibold">{{ tButtons('add_workspace') }}</span>
        </app-tb-button>
    </div>
</app-modal-layout>
